export enum WsEvents {
  SensorGroupDataUpdate = 'sensorGroupDataUpdate',
}
